"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleSwitch = void 0;
var polished_1 = require("polished");
var react_1 = __importDefault(require("react"));
var react_switch_1 = __importDefault(require("react-switch"));
var styled_components_1 = __importStar(require("styled-components"));
var styles = {
    outline: 3,
};
var Toggle = (0, styled_components_1.default)(react_switch_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n\n  &:focus,\n  &:focus-within {\n    outline: ", " solid\n      ", ";\n    outline-offset: ", ";\n  }\n\n  ", "\n"], ["\n  display: flex;\n\n  &:focus,\n  &:focus-within {\n    outline: ", " solid\n      ", ";\n    outline-offset: ", ";\n  }\n\n  ", "\n"])), (0, polished_1.rem)(styles.outline), function (_a) {
    var theme = _a.theme;
    return theme.colors.outline.focus;
}, (0, polished_1.rem)(styles.outline), function (_a) {
    var disabled = _a.disabled;
    return disabled &&
        "\n    & > * {\n      cursor: not-allowed !important;\n    }\n  ";
});
/**
 * A simple toggle switch component used to toggle between two states.
 *
 * This uses the `react-switch` library under the hood.
 */
var ToggleSwitch = function (_a) {
    var isChecked = _a.isChecked, onChange = _a.onChange, label = _a.label, disabled = _a.disabled, _b = _a.className, className = _b === void 0 ? '' : _b;
    var colors = (0, styled_components_1.useTheme)().colors;
    return (react_1.default.createElement(Toggle, { className: "toggle-switch ".concat(className, " ").concat(disabled ? 'disabled' : ''), tabIndex: disabled ? -1 : 0, "aria-label": label, "aria-checked": isChecked, onChange: function () {
            onChange(!isChecked);
        }, width: 43, height: 22, checked: isChecked, uncheckedIcon: false, checkedIcon: false, onColor: colors.toggle.on, offColor: colors.toggle.off, disabled: disabled, activeBoxShadow: "0 0 0px 0px #fff" }));
};
exports.ToggleSwitch = ToggleSwitch;
var templateObject_1;
